var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          directives: [
            {
              name: "permit",
              rawName: "v-permit:remove",
              value: _vm.permission,
              expression: "permission",
              arg: "remove",
            },
          ],
          attrs: { type: "danger", size: "small" },
          on: { click: _vm.removeFeetype },
        },
        [_vm._v(_vm._s(_vm.$t("receivablePayable.Delete")))]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("receivablePayable.DeleteTheFee"),
            visible: _vm.isBool,
            width: "500px",
            loading: _vm.loading,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isBool = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "p",
                { staticStyle: { color: "red", "margin-bottom": "20px" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "receivablePayable.NoteAllDataSelectedChargeDeleted"
                      )
                    ) + " "
                  ),
                ]
              ),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("basicData.ExpenseType"),
                        prop: "feeTypeCode",
                      },
                    },
                    [
                      _c("FeeCodeCmp", {
                        attrs: {
                          val: _vm.ruleForm.feeTypeCode,
                          "business-type": _vm.payableType,
                        },
                        on: { change: _vm.onChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.isBool = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }